import { OVERLAPS_TABLE_SUCCESS, OVERLAPS_TABLE_REQUEST, OVERLAPS_TABLE_FAILURE } from '../../constant';

const initialState = {
  data: [],
  loading: true,
};

const overlapsTable = (state = initialState, action) => {
  switch (action.type) {
    case OVERLAPS_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OVERLAPS_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case OVERLAPS_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default overlapsTable;
